const ITEMS = ["Anmeldung", "Ummeldung", "Abmeldung", "Wunschkennzeichen", "Kurzzeitkennzeichen", "Ausfuhrkennzeichen", "Online-Zulassung", "Express-Zulassung"];

const PlateChip = ({ label }) => (
  <span className="inline-flex items-stretch bg-white text-ink border-2 border-ink/80 rounded-md overflow-hidden shadow-sm">
    <span className="flex flex-col items-center justify-end bg-plate text-white text-[9px] sm:text-[10px] font-bold px-1 sm:px-1.5 pb-1">D</span>
    <span className="dp text-base sm:text-xl md:text-2xl px-3 sm:px-4 py-1 sm:py-1.5 tracking-wide">{label}</span>
  </span>
);

export const Marquee = () => (
  <div className="bg-navy overflow-hidden py-3.5 sm:py-5 shadow-[inset_0_10px_18px_-10px_rgba(0,0,0,0.6),inset_0_-10px_18px_-10px_rgba(0,0,0,0.6)]" aria-hidden="true" data-testid="services-marquee">
    <div className="[mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]">
      <div className="mq gap-3 sm:gap-6 pr-3 sm:pr-6">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <PlateChip key={i} label={item} />
        ))}
      </div>
    </div>
  </div>
);
